import {useMemo} from 'react'
// eslint-disable-next-line @github-ui/github-monorepo/restrict-relay-imports
import {AutomatedCommentSource} from '@github-ui/diff-lines/conversation-types'

export function useAutomatedReviewCommentActions(automatedComment: {
  isDismissed: boolean
  viewerCanDismiss: boolean
  viewerCanReopen: boolean
  source: string
}) {
  return useMemo(() => {
    const isDismissed = automatedComment.isDismissed
    const isDismissable = !isDismissed
    const isReopenable = isDismissed

    let resourceName = 'alert'
    if (
      automatedComment.source === AutomatedCommentSource.CodeQuality ||
      automatedComment.source === AutomatedCommentSource.CodeScanningAi
    ) {
      resourceName = 'finding'
    }
    const isLicenseCompliance = automatedComment.source === AutomatedCommentSource.LicenseCompliance
    const toggleButtonLabel = isDismissed
      ? `Reopen ${resourceName}`
      : isLicenseCompliance
        ? `Close ${resourceName}`
        : `Dismiss ${resourceName}`

    return {
      isDismissed,
      isDismissable,
      isReopenable,
      resourceName,
      toggleButtonLabel,
    }
  }, [automatedComment])
}
